import { __ } from '@wordpress/i18n';
import { useState } from 'react';
import SbUtils from '../../../Utils/SbUtils'
import { ProsIcon, ConsIcon } from '../../Common/Icons/ReviewIcons'

const PostText = ( { post, postIndex, feedSettings } ) => {
    const providerName = post?.provider?.name?.toLowerCase();
    const newProviders = ['booking', 'woocommerce', 'airbnb', 'aliexpress'];
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [lightboxIndex, setLightboxIndex] = useState(0);

    // Lightbox component
    const Lightbox = ({ photos, currentIndex, onClose }) => {
        const [index, setIndex] = useState(currentIndex);

        const handlePrev = (e) => {
            e.stopPropagation();
            setIndex((index - 1 + photos.length) % photos.length);
        };

        const handleNext = (e) => {
            e.stopPropagation();
            setIndex((index + 1) % photos.length);
        };

        const getImageUrl = (photo) => {
            return photo['1280_900'] || photo['500_500'] || photo['90_90'];
        };

        return (
            <div
                className="sbr-lightbox-overlay"
                onClick={onClose}
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.9)',
                    zIndex: 99999,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <button
                    onClick={handlePrev}
                    style={{
                        position: 'absolute',
                        left: '20px',
                        background: 'rgba(255,255,255,0.9)',
                        border: 'none',
                        borderRadius: '50%',
                        width: '50px',
                        height: '50px',
                        fontSize: '24px',
                        cursor: 'pointer',
                        zIndex: 100000
                    }}
                >
                    ‹
                </button>

                <img
                    src={getImageUrl(photos[index])}
                    alt="Review photo"
                    style={{
                        maxWidth: '90%',
                        maxHeight: '90%',
                        objectFit: 'contain'
                    }}
                    onClick={(e) => e.stopPropagation()}
                />

                <button
                    onClick={handleNext}
                    style={{
                        position: 'absolute',
                        right: '20px',
                        background: 'rgba(255,255,255,0.9)',
                        border: 'none',
                        borderRadius: '50%',
                        width: '50px',
                        height: '50px',
                        fontSize: '24px',
                        cursor: 'pointer',
                        zIndex: 100000
                    }}
                >
                    ›
                </button>

                <button
                    onClick={onClose}
                    style={{
                        position: 'absolute',
                        top: '20px',
                        right: '20px',
                        background: 'rgba(255,255,255,0.9)',
                        border: 'none',
                        borderRadius: '50%',
                        width: '40px',
                        height: '40px',
                        fontSize: '24px',
                        cursor: 'pointer',
                        zIndex: 100000
                    }}
                >
                    ×
                </button>
            </div>
        );
    };

    // Booking.com specific template
    const renderBookingTemplate = () => {
        const hasTitle = post?.title;
        const hasPros = post?.metadata?.pros;
        const hasCons = post?.metadata?.cons;
        const reviewerPhotos = post?.reviewer_photos || [];

        return (
            <>
                {hasTitle && (
                    <div className='sb-item-title sb-fs' style={{ marginBottom: '12px' }}>
                        <strong>{post.title}</strong>
                    </div>
                )}
                {(hasPros || hasCons) && (
                    <div className='sb-item-pros-cons' style={{ marginBottom: '12px' }}>
                        {hasPros && (
                            <div className='sb-item-pros' style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '8px', clear: 'both' }}>
                                <ProsIcon />
                                <span className='sb-pros-text'>{SbUtils.printText(post.metadata.pros, feedSettings)}</span>
                            </div>
                        )}
                        {hasCons && (
                            <div className='sb-item-cons' style={{ display: 'flex', alignItems: 'flex-start' }}>
                                <ConsIcon />
                                <span className='sb-cons-text'>{SbUtils.printText(post.metadata.cons, feedSettings)}</span>
                            </div>
                        )}
                    </div>
                )}
                {reviewerPhotos.length > 0 && (
                    <div className='sb-reviewer-photos' style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, 80px)', gap: '10px', marginTop: '12px' }}>
                        {reviewerPhotos.map((photo, idx) => (
                            <div
                                key={idx}
                                onClick={() => {
                                    setLightboxIndex(idx);
                                    setLightboxOpen(true);
                                }}
                                style={{
                                    width: '80px',
                                    height: '80px',
                                    cursor: 'pointer',
                                    overflow: 'hidden',
                                    borderRadius: '4px'
                                }}
                            >
                                <img
                                    src={photo['90_90']}
                                    alt={`Review photo ${idx + 1}`}
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover'
                                    }}
                                />
                            </div>
                        ))}
                    </div>
                )}
                {lightboxOpen && reviewerPhotos.length > 0 && (
                    <Lightbox
                        photos={reviewerPhotos}
                        currentIndex={lightboxIndex}
                        onClose={() => setLightboxOpen(false)}
                    />
                )}
            </>
        );
    };

    // Default template for other new providers (can be customized later)
    const renderDefaultNewProviderTemplate = () => {
        return SbUtils.printText(post?.text ?? '', feedSettings);
    };

    // Check if this is a new provider with custom template
    const renderContent = () => {
        if (newProviders.includes(providerName)) {
            switch (providerName) {
                case 'booking':
                    return renderBookingTemplate();
                case 'woocommerce':
                case 'airbnb':
                case 'aliexpress':
                    return renderDefaultNewProviderTemplate();
                default:
                    return SbUtils.printText(post?.text ?? '', feedSettings);
            }
        }
        // Default template for existing sources (Google, Yelp, Facebook, etc.)
        return SbUtils.printText(post?.text ?? '', feedSettings);
    };

    return (
        <div className='sb-item-text sb-fs'>
            {renderContent()}
            { SbUtils.addHighlighter( 'post-text', 'Paragraph' , postIndex ) }
        </div>
    )

}

export default PostText;